import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock, OverlayTrigger, Tooltip } from 'react-bootstrap';

export default class InputField extends Component {
	labelWithInfo(labelText, infoText) {
		const { id } = this.props;
	
		return (
			<div>
				{labelText}&nbsp;
				<OverlayTrigger
					placement="top"
					overlay={
						<Tooltip id={`${id}-explanation`} style={{ zIndex: 99999 }}>
							{infoText}
						</Tooltip>
					}
				>
					<FontAwesomeIcon icon='question-circle' />
				</OverlayTrigger>
			</div>
		);
	}

	render() {
		const {
			placeholder,
			disabled,
			type,
			input,
			meta: { error, touched },
			label,
			autoComplete,
			id,
			layout,
			textarea,
			rows,
			helpText,
			infoText,
		} = this.props;

		const showError = error && touched;
		const sanitizedLabel = !infoText ? label : this.labelWithInfo(label, infoText);

		const inputBlock = () => {
			return (
				<div>
					<FormControl
						rows={rows || '6'}
						componentClass={textarea ? 'textarea' : 'input'}
						type={type}
						min={type === 'number' ? 0.00 : null}
						step={type === 'number' ? 0.01 : null}
						placeholder={placeholder}
						onChange={input.onChange}
						name={input.name}
						value={input.value}
						disabled={disabled}
						autoComplete={autoComplete ? 'on' : 'off'}
					/>
					<FormControl.Feedback />
					{
						showError ? (
							<HelpBlock>{error}</HelpBlock>
						) :
						(
							<HelpBlock>{helpText || ''}</HelpBlock>
						)
					}
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{sanitizedLabel}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (
			<FormGroup
				controlId={id || input.name}
				className={label ? 'label-present' : 'label-blank'}
				validationState={showError ? 'error' : null}
			>
				{label ? <ControlLabel>{sanitizedLabel}</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}
